import { Component, OnInit, OnDestroy, Injectable }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import {CORE_DIRECTIVES, FORM_DIRECTIVES, NgClass, NgIf} from '@angular/common';
import { IStaffingStandardsTracon } from './staffing-standards-tracon-list';
import { StaffingStandardsTraconService } from './staffing-standards-tracon.service';
import { UserSession } from '../../../shared/user-session';


import {DataTable} from 'primeng/primeng';
import {Column} from 'primeng/primeng';
import {Header} from 'primeng/primeng';
import {Button} from 'primeng/primeng';
import {Paginator} from 'primeng/primeng';


@Component({
    //templateUrl: 'app/system-management/staffing-standards/staffing-standards-tracon/staffing-standards-tracon.component.html',
    template: require('./staffing-standards-tracon.component.html'),
    directives: [ROUTER_DIRECTIVES,DataTable,Column, Header, Paginator],
        providers: [StaffingStandardsTraconService]
})

export class StaffingStandardsTraconComponent implements OnInit, OnDestroy{
    pageTitle: string = 'Staffing Standards Tracon';
    errorMessage: string;
    staffingStandardsTraconArr: IStaffingStandardsTracon;
    private sub: any;
    cols: any[];
    scenario: number;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private _staffingStandardsTraconService: StaffingStandardsTraconService,
                private User: UserSession){
                    
    }

    ngOnInit(): void{
        this.scenario = this.User.getSession().scenarioId;
            this._staffingStandardsTraconService.getSSTracon(this.scenario)
            .subscribe(
                staffingStandardsTraconArr => this.staffingStandardsTraconArr = staffingStandardsTraconArr,
                error =>  this.errorMessage = <any>error);
         this.cols = [
            {field: "locid", header: 'Locid'},
            {field: "year", header: 'Year'},
            {field: "ac", header: 'Air Carrier'},
            {field: "at", header: 'Air Taxi'},
            {field: "ga", header: 'General Aviation'},
            {field: "mil", header: 'Military'},
            {field: "totOvers", header: 'Total Overflights'},
            {field: "totOps", header: 'Total Operations'},
        ]
       // console.log('Staffing Standards Tracon Component: ' +  JSON.stringify(this.cols));
    }

    ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
   
}



/** WEBPACK FOOTER **
 ** ./app/system-management/staffing-standards/staffing-standards-tracon/staffing-standards-tracon.component.ts
 **/